@use "../../style/variables" as *;
@use "../../style/mixins" as *;

.coupon-container {
  position: relative;
}

.coupon-slider {
  position: relative;
  @include mobile {
    margin-right: 0;
    margin-left: 0;
  }

  //hides border of last coupon
  > .coupon:last-child .card {
    border-bottom: none;
    margin-bottom: 0;
  }
}

.coupon {
  width: 30rem;
  max-width: 100%;
  margin-left: auto;

  @include mobile {
    width: auto;
  }
}

.card {
  margin: 0 0 1.625rem;
  @include separator-bottom;

  @include mobile {
    margin-bottom: 1rem;
    margin-left: 0;
    margin-right: 0;
  }

  .rich-media {
    cursor: pointer;
    position: relative;
    padding-top: 56.25%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-color: $black;
  }

  .supporting-text {
    margin-top: 1rem;

    @include mobile {
      line-height: 1.125rem;
    }

    .title {
      font-weight: 100;
      color: $ny-red;
      font-size: 1.5rem;
      line-height: 1.875rem;
    }

    .subtitle {
      margin-top: .5rem;
      margin-bottom: 2rem;
      font-weight: 300;
      color: $grey-text;
      font-size: 1rem;
      line-height: 1.25rem;

      @include mobile {
        margin-top: 0.375rem;
        margin-bottom: 1.5rem;
      }
    }

    .icon svg {
      width: 0.75rem;
      height: 0.75rem;
      vertical-align: top
    }

    /* Solid icons get a fill */
    .solid {
      fill: #888888;
      stroke: none
    }

    .date-container {
      margin-top: 0.75rem;
      margin-bottom: 1.5rem;

      .date {
        display: flex;
        justify-content: center;

        font-size: 0.75rem;
        line-height: 0.75rem;
        color: #888888;

        @include mobile {
          font-size: 0.625rem;
          line-height: 0.75rem;
        }

        .validity {
          margin-left: 0.25rem;
        }
      }
    }

  }

  .pointsContainer {
    position: relative;
  }

  .points {
    position: absolute;
    bottom: 1.25rem;
    right: 1.25rem;
    width: 5rem;
    height: 3.125rem;
    border-radius: 8px;
    color: $white;
    background-color: $grey-text;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @include mobile {
      bottom: 0.875rem;
      right: 1rem;
      width: 4rem;
      height: 2.5rem;
      border-radius: 6px;
    }

    .pointsValue {
      font-weight: 500;
      font-size: 1.125rem;
      line-height: 1.125rem;

      @include mobile {
        font-weight: 500;
        font-size: 0.875rem;
        line-height: 1rem;
      }
    }

    .pointsText {
      font-weight: 100;
      font-size: 0.75rem;
      text-transform: uppercase;
      line-height: 0.75rem;
      letter-spacing: 0.075rem;

      @include mobile {
        font-size: 0.625rem;
        line-height: 0.625rem;
      }
    }
  }

}
